import { useQuery } from '@tanstack/react-query';
import {
  type ConfigCustomFieldDto,
  configControllerGetPublicProductConfigQueryOptions,
  policyControllerGetPolicyQueryOptions,
} from 'korint-sdk';
import { sortBy } from 'lodash';
import { useParams } from 'react-router-dom';

export const fieldsOnDynamicStep = (fields: ConfigCustomFieldDto[] | undefined, stepKey: string) =>
  (fields ?? []).filter(({ display }) => display?.step === stepKey);

export function useDynamicSteps(enabled = true) {
  const { policyId, branchId } = useParams();

  const { data: policy } = useQuery({
    ...policyControllerGetPolicyQueryOptions(policyId ?? '', { branchId }),
    enabled: enabled && Boolean(policyId),
  });
  const { data: config } = useQuery({
    ...configControllerGetPublicProductConfigQueryOptions(policy?.productId ?? ''),
    enabled: enabled && Boolean(policy?.productId),
  });

  const steps = sortBy(config?.steps ?? [], 'position').filter(
    ({ key }) =>
      fieldsOnDynamicStep(config?.customerFields, key).length > 0 ||
      fieldsOnDynamicStep(config?.policyFields, key).length > 0 ||
      fieldsOnDynamicStep(config?.assetFields, key).length > 0,
  );

  return { config, steps };
}
